import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LimitService {
  private limitChangedSubject = new BehaviorSubject<boolean>(false);
  limitChanged$ = this.limitChangedSubject.asObservable();

  notifyLimitOrRangeChanged() {
    this.limitChangedSubject.next(true);
  }
  notifyLimitnotifyLimitOrRangeChangedReset() {
    this.limitChangedSubject.next(false);
  }
  
}
